export default __webpack_public_path__ + "static/media/meet_storycards_video.e0c7e5e9.jpeg";